<template>
  <div class="main-visual">
    <div class="bg-color"></div>
    <div class="neon-card">
      <div class="neon-card-center">
        <h2 class="mb-24 mt-0 text-bold text-center">
          {{ state.consentTitleText }}
        </h2>
        <p class="text-body">
          {{ state.consentDisplayText }}
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive } from 'vue';

export default defineComponent({
  name: 'FailureScreen',
  setup() {
    const state = reactive({
      consentTitleText: '',
      consentDisplayText: '',
      clientName: 'Microsoft Teams', // TODO: BOT-746: Resolve dynamically
      clientIconUrl: require('../assets/icons/teams-and-company-logo.svg'), // TODO: Resolve dynamically & Separate by Target icon and COMPANY icons
    });

    const closeWindowBtn = () => self.window.close();

    state.consentTitleText = `${state.clientName} との連携を拒否しました`
    state.consentDisplayText = `ウィンドウを閉じてください。連携したい場合は、操作をやり直してください。`

    return {
      state,
      closeWindowBtn,
    };
  },
});
</script>

<style lang="scss" scoped>
// 共通スタイル
.main-visual {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}

.bg-color {
  background: linear-gradient(
    45deg,
    rgba(0, 91, 172, 1),
    rgba(94, 194, 198, 1) 100%
  );
  bottom: 0;
  height: 100%;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: -1;
}

.neon-card {
  max-height: 100%;
  transform-origin: center center;
  overflow-y: auto;
  width: 100%;
}

.text-center {
  text-align: center;
}

// デスクトップビュー（768px以上）
@media screen and (min-width: 768px) {
  .main-visual {
    padding: 16px;
  }

  .neon-card-center {
    background-color: #ffffff;
    border-radius: 4px;
    height: auto;
    max-width: 524px;
    padding: 48px;
    margin: 0 auto;
  }

  .text {
    &-bold {
      font-size: 18px;
      font-weight: bold;
      line-height: 1.5;
    }
    &-body {
      font-size: 16px;
      line-height: 1.6;
    }
  }
}

// タブレットビュー（510px〜767px）
@media screen and (min-width: 510px) and (max-width: 767px) {
  .main-visual {
    padding: 16px;
  }

  .neon-card-center {
    background-color: #ffffff;
    border-radius: 4px;
    height: auto;
    max-width: 524px;
    padding: 32px;
    margin: 0 auto;
  }

  .text {
    &-bold {
      font-size: 17px;
      font-weight: bold;
      line-height: 1.5;
    }
    &-body {
      font-size: 15px;
      line-height: 1.6;
    }
  }
}

// モバイルビュー（360px〜509px）
@media screen and (min-width: 360px) and (max-width: 509px) {
  .main-visual {
    padding: 16px;
  }

  .neon-card-center {
    background-color: #ffffff;
    border-radius: 4px;
    height: auto;
    width: 100%;
    padding: 24px;
  }

  .text {
    &-bold {
      font-size: 16px;
      font-weight: bold;
      line-height: 1.5;
    }
    &-body {
      font-size: 14px;
      line-height: 1.6;
    }
  }
}

// 小型モバイルビュー（359px以下）
@media screen and (max-width: 359px) {
  .main-visual {
    padding: 12px;
  }

  .neon-card-center {
    background-color: #ffffff;
    border-radius: 4px;
    height: auto;
    width: 100%;
    padding: 16px;
  }

  .text {
    &-bold {
      font-size: 14px;
      font-weight: bold;
      line-height: 1.5;
    }
    &-body {
      font-size: 13px;
      line-height: 1.6;
    }
  }
}
</style>
